import type { ReportColumn } from './ReportDataTable'

export type MetricRow = { metric: string; value: string | number }

export const METRIC_TABLE_COLUMNS: ReportColumn<MetricRow>[] = [
  { key: 'metric', header: 'Metric' },
  { key: 'value', header: 'Value' },
]
